import dayjs from '~/timeInit';

import type { CommercialRow } from './types';

export function commercialHistorySeries(rows: Array<CommercialRow>, endDate: string, days: number) {
  const byDate = new Map(rows.map((row) => [`${row.observation_date ?? row.report_date}:${row.product_bk}`, row]));
  return Array.from({ length: days }, (_, index) => {
    const date = dayjs(endDate)
      .subtract(days - index - 1, 'day')
      .format('YYYY-MM-DD');
    const margin = (product: string) => {
      const row = byDate.get(`${date}:${product}`);
      return row?.margin_observed_rows && row.margin_ar_aud != null && Number.isFinite(row.margin_ar_aud)
        ? row.margin_ar_aud
        : null;
    };
    return { date, LPC: margin('tactical_ao_hotel'), LPP: margin('bedbank') };
  });
}
